import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["getHeaderTitle", "actionMetadata", "flowObjectTypeId", "actionId"];
import PropTypes from 'prop-types';
// @ts-expect-error untyped module customer-data-objects-ui-components
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import CreateObjectActionMetadata from 'automation-ui-action-features/actions/create-object/records/CreateObjectActionMetadata';
import CreateObjectActionSummary from 'automation-ui-action-features/actions/create-object/CreateObjectActionSummary';
import { jsx as _jsx } from "react/jsx-runtime";
function CreateObjectActionCard(_ref) {
  let {
      getHeaderTitle,
      actionMetadata,
      flowObjectTypeId,
      actionId
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({}, rest, {
    headerTitle: getHeaderTitle({
      actionId: actionId
    }),
    content: /*#__PURE__*/_jsx(CreateObjectActionSummary, {
      metadata: actionMetadata,
      flowObjectTypeId: flowObjectTypeId
    })
  }));
}
CreateObjectActionCard.propTypes = {
  getHeaderTitle: PropTypes.func.isRequired,
  actionMetadata: PropTypes.instanceOf(CreateObjectActionMetadata).isRequired,
  flowObjectTypeId: ObjectTypeIdType.isRequired,
  actionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default CreateObjectActionCard;